@if (computedFields.visible !== undefined ? computedFields.visible : true) {
    @if (computedFields.disabled || action.disabled) {
        <span>{{ action.text | translate }}</span>
    } @else {
        <a class="listingsTableLink" (click)="handleClick($event)" [attr.title]="computedFields.tooltip || action.tooltip">
            {{ action.text | translate }}
        </a>
    }
}
